import { z } from "zod/v4";

export const ProductUpdateSchema = z.object({
  title: z.string().min(1, "Please enter a title"),
  severity: z.number(),
  content: z.string().min(1, "Please enter a message"),
});

export type ProductUpdateForm = z.infer<typeof ProductUpdateSchema>;
